import React, { FunctionComponent, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { Card, CardActionArea, Grid, GridSize, Skeleton, useTheme } from "@mui/material";
import { strings } from "../../../../localization/LocalizedStrings";
import { IImpact, useGetImpacts } from "../../../../hooks/impacts";
import { AttributeDesktop } from "../../AttributeDesktop";
import { useUserProfile } from "../../../../hooks/session";
import { attributeIconMap } from "../../../../models/AttributeUtilities";
import { AttributeType } from "../../AttributeList";
import { StarsRating } from "../StarsRating";

export const ImpactsDesktop: FunctionComponent<IImpactsDesktopProps> = ({
  handleClose,
  columnWidth,
  preselectedId,
  onImpactSelected,
  onClearValue
}) => {
  const theme = useTheme();
  const [currentUserProfile] = useUserProfile.useState();
  const [loading, setLoading] = useState(false);
  const impacts = useGetImpacts(setLoading, []);
  const [searchText, setSearchText] = useState("");
  const filteredImpacts = useMemo(() => {
    if (searchText == "") {
      return impacts;
    }
    return impacts?.filter(impact => {
      return impact.description.toLowerCase().includes(searchText.toLowerCase());
    });
  }, [impacts, searchText]);
  return (
    <AttributeDesktop
      handleClose={handleClose}
      isPublic={false}
      items={filteredImpacts}
      emptyIconType={attributeIconMap[AttributeType.IMPACTS]}
      emptyString={strings.empty_impacts}
      title={strings.attribute_impacts_title}
      loading={loading}
      setLoading={setLoading}
      onSearchRequested={searchText => setSearchText(searchText)}
      onClearValue={onClearValue}
    >
      {filteredImpacts?.map(impact => (
        <Grid item key={impact.id} xs={columnWidth}>
          <Card sx={{ height: 80, borderRadius: "20px" }} elevation={5}>
            <CardActionArea
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
              }}
              style={{
                borderColor: theme.palette.colors?.highlightBorder,
                borderWidth: 4,
                borderStyle: preselectedId == impact.id ? "double" : "none"
              }}
              onClick={() => onImpactSelected?.(impact)}
            >
              <StarsRating value={impact.id} />
              {currentUserProfile?.shouldShowImpactDescriptions && (
                <p className={styles.name}>{impact.description}</p>
              )}
            </CardActionArea>
          </Card>
        </Grid>
      ))}
      {loading &&
        Array.from({ length: 6 }, (value, index) => (
          <Grid key={index} item xs={columnWidth}>
            <Skeleton variant={"rectangular"} sx={{ height: 80 }} className={styles.skeleton} />
          </Grid>
        ))}
    </AttributeDesktop>
  );
};

export interface IImpactsDesktopProps {
  handleClose?: () => void;
  columnWidth: GridSize;
  preselectedId?: number;
  onImpactSelected?: (impact: IImpact) => void;
  onClearValue?: () => void;
}
